var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MediaStorageCropperProvider',{scopedSlots:_vm._u([{key:"default",fn:function({ cropperProps }){return [_c('cropper',_vm._g(_vm._b({ref:"cropper",staticClass:"cropper",attrs:{"debounce":300},on:{"ready":_vm.onCropperReady}},'cropper',{
        ...cropperProps(_vm.tag).props,
        ..._vm.$attrs,
      },false),_vm.$listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }